import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "jr-flex jr-justify-center jr-items-center jr-text-sm jr-px-5 jr-w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "jr-text-primary jr-font-bold jr-mb-1" }, "エリア来訪時", -1)
const _hoisted_3 = { class: "jr-align-middle jr-ml-2" }
const _hoisted_4 = { class: "jr-relative jr-flex-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "jr-text-xs jr--mb-3.5 jr-ml-4" }, "(%)", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "jr-text-primary jr-font-bold jr-mb-1" }, "エリア内", -1)
const _hoisted_7 = { class: "jr-align-middle jr-ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("figure", null, [
      _hoisted_2,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitAreaLegend.slice().reverse(), (d, i) => {
          return (_openBlock(), _createElementBlock("li", { key: i }, [
            _createElementVNode("div", {
              class: "jr-w-4 jr-h-4 jr-inline-block jr-align-middle",
              style: _normalizeStyle({ 'background-color': d.color })
            }, null, 4),
            _createElementVNode("span", _hoisted_3, _toDisplayString(d.name) + " " + _toDisplayString(d.volume) + "%", 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_BarChart, _normalizeProps(_guardReactiveProps(_ctx.barChartProps)), null, 16)
    ]),
    _createElementVNode("figure", null, [
      _hoisted_6,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inAreaLegend.slice().reverse(), (d, i) => {
          return (_openBlock(), _createElementBlock("li", { key: i }, [
            _createElementVNode("div", {
              class: "jr-w-4 jr-h-4 jr-inline-block jr-align-middle",
              style: _normalizeStyle({ 'background-color': d.color })
            }, null, 4),
            _createElementVNode("span", _hoisted_7, _toDisplayString(d.name) + " " + _toDisplayString(d.volume) + "%", 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}